import BarChart from './BarChart';

export default BarChart;


// WEBPACK FOOTER //
// ./resources/assets/js/components/BarChart/index.js